export const mapNodes = (node) => {
    return node?.['@nodes']?.map((subNode) => node[subNode]) ?? [];
};

export const hasNodes = (node) => {
    return node?.['@nodes']?.length > 0;
};

export const hasValue = (value) => {
    return value && value !== 'none';
};
export const containsNodesOfType = (nodes = [], containTypes = []) => {
    const nodeTypes = nodes.map((node) => node['@nodeType']);
    return containTypes.some((containType) => nodeTypes.includes(containType));
};

export const filterNodesByType = (nodes = [], type = '') => {
    return nodes.filter((node) => node['@nodeType'].includes(type));
};
export const filterNodesByTemplate = (nodes = [], type = '') => {
    return nodes.filter((node) => node['mgnl:template']?.includes(type));
};

export const filterNodesByTypes = (nodes = [], containTypes = []) => {
    return nodes.filter((node) => containTypes.includes(node['@nodeType']));
};
export const getId = (node) => {
    return node?.['@id'] ?? '@id';
};

export const getPath = (node) => {
    return node?.['@path'] ?? '@path';
};

export const getTemplate = (node) => {
    return node?.['mgnl:template'] ?? 'mgnl:template';
};

export const imageName = (image) => {
    return image?.metadata?.fileName ?? '';
};

export const getImageWidth = (image) => {
    const metadata = getImageMetaData(image);
    return metadata?.width > 0 ? metadata?.width : null;
};

export const getImageHeight = (image) => {
    const metadata = getImageMetaData(image);
    return metadata?.height > 0 ? metadata?.height : null;
};

export const getImageMetaData = (image) => {
    // should return description
    return image?.metadata ?? {};
};

export const getImageAlt = (image) => {
    // should return description
    return getImageMetaData(image)?.description ?? '';
};
export const getImageTitle = (image) => {
    // should return title
    return getImageMetaData(image)?.title ?? '';
};

export const isDamImage = (image) => image?.['@nodeType'] !== 'mgnl:contentNode' && !!image?.['@id'];

export const containsImage = (image) => isDamImage(image);

/**
 * Reduziert mehrfaches "/" zu einem "/", aber lässt "://" unangetastet.
 *
 * @param {string} url
 * @returns {string}
 */
export function normalizeUrlSlashes(url) {
    return String(url).replace(/([^:]\/)\/+/g, '$1');
}

export function decodeIfEscaped(text) {
    if (!text) return '';

    if (text.includes('&lt;') || text.includes('&gt;')) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.documentElement.textContent;
    }
    return text;
}

export function getAnnotation(templateAnnotations, content) {
    return templateAnnotations?.[content?.['@path']] ?? '';
}
